<template>
  <div>
    <el-upload
      :auto-upload="false"
      :show-file-list="false"
      :on-change="onChange"
      :on-remove="remove"
      :before-upload="beforeAvatarUpload"
      class="avatar-uploader upimg"
      drag
      action="#"
      name="filename0"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
  </div>
</template>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<script>
// import lrz from "lrz";
export default {
  name: "UmImg",
  data() {
    return {
      imageUrl: "",
      avatarname: [],
      fileList: []
    };
  },
  mounted() {
    this.imageUrl = this.uploadlogo;
  },
  props: ["uploadlogo", "submitStatus"],
  watch: {
    uploadlogo(val) {
      this.imageUrl = val;
    },
    submitStatus(val) {
      if (val) {
        if (this.fileList.length > 0) {
          var formData = new FormData(); //  用FormData存放上传文件
          this.fileList.forEach((file, index) => {
            formData.append("filename" + index, file.raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
          });
          $UMCore
            .post(window.fileurl, formData)
            .then(res => {
              this.fileList=[]
              this.$emit("submit-file", res.data[0]);
            })
            .catch(error => {
              this.$message.error("上传失败！");
              return false;
            });
        } else {
          this.fileList=[]
          this.$emit("submit-file", '');
        }
      }
    }
  },
  methods: {
    onChange(file, fileList) {
      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      // this.fileList = fileList;
      lrz(file.raw)
        .then(rst => {
          // 处理成功会执行
          file.raw = this.dataURLtoFile(rst.base64, file.raw.name);
          if(file.size/1024/1024>100){
            this.$message.error("文件上传不能超过100M！");
          }else{
            if (this.imageUrl) {
                this.imageUrl = URL.createObjectURL(file.raw);
            }
            this.fileList=[];
            this.fileList.push(file);
            this.$emit("getImgSrc", URL.createObjectURL(file.raw));
          }
        })
        .catch(err => {
          this.$message.error("目前仅支持jpg,png,gif,jpeg格式！");
          // this.fileList.push(file);
          // 处理失败会执行
        })
        .always(function() {
          // 不管是成功失败，都会执行
        });
    },
    dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.avatarname.push(res[0].filename);
      this.$emit("getImgSrc", res[0]);
    },
    error(res) {
      this.$message.error("文件上传失败！");
      this.$emit("getImgSrc", "");
    },
    remove() {
      this.$emit("getImgSrc", "");
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isJPG) {
        this.$message.error("目前仅支持jpg,png,gif格式！");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 100MB！");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/packages/img/um-img.vue